import { toFieldCategory } from '@atlassian/jira-common-rest/src/internal/simplified/1.0/projects/id/issuetypes/id/types.tsx';
import { toPackageName } from '@atlassian/jira-project-settings-apps-common/src/consts.tsx';
import type { PackageName } from '@atlassian/jira-project-settings-apps-common/src/types.tsx';

/**
 * Issue type hierarchy means Epic / Story / SubTask levels.
 * Advanced roadmaps support more levels even, and custom levels too.
 * JSM TMP supports none of this, and all issue types (which are the same entity as request types)
 * are on the same level.
 *
 * This makes SWIFT behave a little bit differently when rendering navigation, redirecting, and deleting issue types.
 */
export const doesJsmTmpSupportIssueTypeHierarchy = (): boolean => false;

export const PACKAGE_NAME: PackageName = toPackageName(
	'jiraProjectSettingsAppsIssueTypePageJsmTmp',
);

export const getRequestFieldCategoryId = () => toFieldCategory('request');
